import { Button, Tab, Tabs } from "carbon-components-react";
import Card from "../../components/Card/Card";
import VacancyForm from "./VacancyForm";
import { ArrowLeft20 } from "@carbon/icons-react";
import InternshipFillingInstructions from "../../components/Miscellaneous/InternshipFillingInstructions";
import { ArrowRight20 } from "@carbon/icons-react";
import { useState } from "react";
import InternshipTermsAndConditions from "../../components/Miscellaneous/InternshipTermsAndConditions";

const CreateVacancyPage = () => {
  const [activeTab, setActiveTab] = useState(0);

  const nextTab = () => {
    setActiveTab((prev) => prev + 1);
  };
  const previousTab = () => {
    setActiveTab((prev) => prev - 1);
  };

  return (
    <Card title="Adicionar Vaga de Estágio">
      <Tabs
        scrollIntoView={false}
        selected={activeTab}
        type={"container"}
        onSelectionChange={(e) => setActiveTab(e)}
      >
        <Tab href="#" id="tab-0" label="Termos e Condições">
          <InternshipTermsAndConditions />
          <div className="tab-navigation">
            <p></p>
            <Button kind="ghost" size="sm" onClick={nextTab}>
              Próximo <ArrowRight20 />
            </Button>
          </div>
        </Tab>
        <Tab href="#" id="tab-1" label="Vaga">
          <VacancyForm operation="CREATE" />
          <div className="tab-navigation">
            <Button kind="ghost" size="sm" onClick={previousTab}>
              <ArrowLeft20 /> Anterior
            </Button>
          </div>
        </Tab>
      </Tabs>
    </Card>
  );
};
export default CreateVacancyPage;
